/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import {
  Modal,
  Typography,
  Form,
  Spin,
} from 'antd';
import React, { useEffect, useState } from 'react';
import Table from 'components/Table';
import { getEstadosGlobales } from 'api/catalogos';
import { getCitasHistorico, getCitasHistoricos } from 'api/reclutamiento/citas';
import { checkToken } from 'api/utils';
import moment from 'moment';

const { Text } = Typography;

const HistoricoCitas = ({ citaId }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);

  const fetchData = async () => {
    if (!citaId) return;
    setLoading(true);
    try {
      const [_estados, _data] = await Promise.all([
        getEstadosGlobales(),
        getCitasHistoricos({ cita: citaId }),
      ]);
      setEstados(_estados);
      setData(_data);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[Histórico de Citas] error al cargar el histórico', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      await checkToken();
      if (mounted && citaId) {
        await fetchData();
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, [citaId]);

  const columns = [
    {
      titleText: 'Fecha',
      dataIndex: 'fecha',
      key: 'fecha',
      width: 150,
      render: (text) => (text ? moment(text).format('YYYY-MM-DD') : '-'),
    },
    {
      titleText: 'Horario',
      dataIndex: 'fecha_y_hora',
      key: 'fecha_y_hora',
      width: 120,
      render: (text) => (text ? moment(text).format('HH:mm') : '-'),
    },
    {
      titleText: 'Justificación',
      dataIndex: 'justificacion',
      key: 'justificacion',
      width: 200,
      render: (text) => text || '-',
    },
  ];

  return (
    <>
      <Text>Histórico de Citas:</Text>
      <Table
        cols={columns}
        data={data}
        rowKey="id"
        pagination={false}
        bordered
        style={{ marginTop: 20 }}
      />
    </>
  );
};

export default HistoricoCitas;
